import React from 'react';
import { Component as RadialChart } from "../ShadRadialChart";

const chartData = [{ month: "january", occupancy: null, vacancy: null }]

const chartConfig = {
  occupancy: {
    label: "תפוס",
    color: "hsl(var(--chart-1))",
  },
  vacancy: {
    label: "פנוי",
    color: "hsl(var(--chart-2))",
  },
}

const locationHebrewName = {
  "KURSI_BEACH": "חוף כורסי",
  // "SHIKMIM": "חוף שיקמים",
  "TSINBERI": /*OriginalHebrewName "חוף צינברי" */"צינברי ושיקמים",
}

function YsbRadialChart({ vacancyValues, totalParkingSpaces, deviceNames }) {
  deviceNames = deviceNames.filter(devices=>(devices !== "SHIKMIM"))
  const [activeMonth, setActiveMonth] = React.useState(deviceNames[0]);
  let totalParkingSpace = totalParkingSpaces[deviceNames.findIndex(deviceName => deviceName === activeMonth)];
  let vacancyValue = vacancyValues[deviceNames.findIndex(deviceName => deviceName === activeMonth)];
  console.log(vacancyValue, totalParkingSpace, deviceNames, "props");
  if (vacancyValue === "אלמ") {
    console.log(vacancyValue, "vacancyValue is null")
    vacancyValue = 0;
    console.log(vacancyValue, "vacancyValue is null")
  }
  chartData[0].occupancy = totalParkingSpace - vacancyValue<0? 0:totalParkingSpace - vacancyValue;
  chartData[0].vacancy = vacancyValue<0? 0:vacancyValue;
  const totalVisitors = totalParkingSpace;


  return (
    <RadialChart
      totalVisitors={totalVisitors}
      chartData={chartData}
      chartConfig={chartConfig}
      locationHebrewName={locationHebrewName}
      deviceNames={deviceNames}
      setActiveMonth={setActiveMonth}
      activeMonth={activeMonth}
      vacancyValue={vacancyValue}
      totalParkingSpace={totalParkingSpace}

    />
  )
}

export default YsbRadialChart;